import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import GraphQLErrors from "../../components/GraphQLErrors";
import {GET_META_ORDER_HISTORY} from "../../queries/sales";
import Table from "../../components/Table";
import MetaOrderItem, {tableHeader} from "../views/MetaOrderItem";
import {fromJS} from "immutable";

class MetaOrderHistoryFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  render() {
    const {loading, error} = this.props.data;

    if (error) return <GraphQLErrors error={error} />;
    
    const historyWithKeys = fromJS(this.props.data.salesMetaOrderHistory?.map((item, i) => {
      return {
        ...item,
        key: i,
      };
    }));

    return (
      <Table
        loading={loading}
        data={historyWithKeys}
        renderer={(props) => <MetaOrderItem {...props} />}
        tableHeader={tableHeader}
        itemKey="key"
        mode="table"
      />
    )
  }
}


const withQuery = compose(
  graphql(GET_META_ORDER_HISTORY, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        metaOrderId: props.metaOrderId,
      },
    })
  }),
);

export default withQuery(MetaOrderHistoryFormContainer);